<style src="./ImageUpload.scss" lang="scss"></style>

<template lang="pug">
  .image-upload(
    @dragover='ondragenter'
    @dragleave='ondragleave'
    @drop='ondragleave'
    :class='classList'
  )
    img.image-upload__image(
      v-if='hasImage'
      :src='getImage()'
    )
    .image-upload__zone
      file-upload(
        :drop='true'
        :name='"cover"'
        @input-filter="inputFilter"
        @input='files => $emit("update-cover", files)'
        ref='upload'
        v-model='files'
      )
</template>

<script>
import FileUpload from "vue-upload-component";

import {
  HOST_URL,
  IMAGES_UPLOAD_TYPES_REGEXP,
  IMAGE_UPLOAD_SIZE_LIMIT
} from "@/constants";

export default {
  props: {
    image: {
      type: String,
      default: ""
    },
    rounded: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      HOST_URL,
      drag: false,
      files: []
    };
  },
  components: {
    FileUpload
  },
  computed: {
    hasImage() {
      return this.files[0] || this.image;
    },
    classList() {
      return {
        "has-image": this.hasImage,
        drop: this.$refs.upload && this.$refs.upload.dropActive,
        drag: this.drag,
        rounded: this.rounded
      };
    }
  },
  methods: {
    getImage() {
      if (this.files[0]) {
        return this.files[0].blob;
      }

      return `${this.HOST_URL}${this.image}`;
    },
    inputFilter(newFile, oldFile, prevent) {
      // adding new image
      if (newFile && !oldFile) {
        if (!IMAGES_UPLOAD_TYPES_REGEXP.test(newFile.name)) {
          this.$toasted.show(this.$l10n("FILE_FORMAT_NOT_SUPPORT"), {
            type: "error"
          });

          return prevent();
        }

        if (newFile.size > IMAGE_UPLOAD_SIZE_LIMIT) {
          const size = IMAGE_UPLOAD_SIZE_LIMIT / 1024 / 1024;

          this.$toasted.show(
            this.$l10n("FILE_SIZE_LARGE_THEN_LIMIT", { size }),
            {
              type: "error"
            }
          );

          return prevent();
        }

        newFile.blob = URL.createObjectURL
          ? URL.createObjectURL(newFile.file)
          : "";
      }

      // updating
      if (newFile && oldFile) {
        newFile.version += newFile.version ? 1 : 0;
      }

      // removing
      if (!newFile && oldFile) {
        this.$toasted.show(this.$l10n("FILE_REMOVED"), {
          type: "info"
        });
      }
    },
    ondragenter() {
      if (!this.drag) {
        this.drag = true;
      }
    },
    ondragleave() {
      if (this.drag) {
        this.drag = false;
      }
    }
  }
};
</script>
